import { makeStyles } from '@material-ui/core'
import { Elements, Grid, RadioButtonGroup, TextButton, Loader, } from '@tfo/common'
import { reaction } from 'mobx'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import RootStore from '../../../../stores/RootStore'
import Form from '../../common/form/Form'
const { Heading3, InputErrorMessage } = Elements
export interface SubCompaniesProps {
	rootStore?: RootStore
}
const useStyles = makeStyles({
	button: {
		width: '100%',
		paddingTop: '5px',
		backgroundColor: '#ec9dc9',
		'&:hover': {
			background: '#edabd0',
		},
	},
	Subsidiaries: {
		marginTop: '10vh',
		maxWidth: '500px',
	},
})

const SubCompanies = ({ rootStore }: SubCompaniesProps) => {
	const intl = useIntl()
	const { clientViewStore } = rootStore
	const style = useStyles()
	const history = useHistory()
	const [subCompanies, setSubCompanies] = React.useState<Array<any>>([])
	const SelectCompanies = {
		selected: null,
		items: subCompanies,
	}
	const [displayErrorMessage, setDisplayErrorMessage] = React.useState(false);

	React.useEffect(() => {
		if (clientViewStore.flatSubsidiaries) {
			let allSubcompanies = []
			clientViewStore.flatSubsidiaries.map(SubCompany => {
				allSubcompanies.push({
					label: [SubCompany.name],
					id: SubCompany.id,
				})
			})
			setSubCompanies(() => allSubcompanies)

		}

	}, [clientViewStore.flatSubsidiaries])


	const onSubmitClick = async () => {
		if (SelectCompanies.selected != null) {
			setDisplayErrorMessage(false)
			history.push(`/service-packages/${SelectCompanies.items[SelectCompanies.selected].id}`)
		} else {
			setDisplayErrorMessage(true)
		}
	}
	return (
		<React.Fragment>
			{
				(subCompanies.length > 0 && clientViewStore.flatSubsidiaries) &&
				<Grid.GridWrapper
					className={style.Subsidiaries + ' GridWrapper StartClient'}>
					<Form
						onSubmit={(e: React.FormEvent) => {
							e.stopPropagation()
							e.preventDefault()
						}}>
						<Heading3>
							{intl.formatMessage({ id: 'common.pick-subcompany' })}
						</Heading3>

						<RadioButtonGroup data={SelectCompanies} name={'SubCompanies'} />
						{displayErrorMessage && <InputErrorMessage>
							{intl.formatMessage({ id: 'common.subcompany-error-message' })}
						</InputErrorMessage>
						}
						<div className={'NewReportOrder__BlockSpace--small'}>
							<TextButton
								className={style.button}
								onClick={() => onSubmitClick()}>
								{intl.formatMessage({ id: 'common.pick-company' })}
							</TextButton>
						</div>
					</Form>
				</Grid.GridWrapper>
			}
			{clientViewStore.loading && <Loader />}
		</React.Fragment>
	)
}

export default inject('rootStore')(observer(SubCompanies))
